<template>
    <div class="col-12 col-sm-6 col-lg-4">
        <div class="box bg-white tariff-block">
          <div class="tariff-block__header">
            <div class="tariff-block__title">{{tariff?.titleRu}}</div>
            <!-- <div class="tariff-block__subtitle color-green">(TV+Internet) ADSL</div> -->
          </div>
          <div class="tariff-block__body">
            <div class="row">
              <div class="col-12 col-md-6">
                <div class="tariff-item">
                  <div class="tariff-item__icon svg-icon color-green" aria-hidden="true">
                    <svg role="img" width="50" height="50" aria-hidden="true">
                      <use xlink:href="#svg-icon-internet"></use>
                    </svg>
                  </div>
                  <div class="tariff-item__content">
                    <div class="tariff-item__title">{{$t("internet")}}</div>
                    <div class="tariff-item__descr color-gray">{{$t("upTo", { count: tariff?.internet?.internetSpeed })}} {{$t("speedUnit")}}</div>
                  </div>
                </div>
              </div>
              <div class="col-12 col-md-6">
                <div class="tariff-item">
                  <div class="tariff-item__icon svg-icon color-green" aria-hidden="true">
                    <svg role="img" width="50" height="50" aria-hidden="true">
                      <use xlink:href="#svg-icon-tv"></use>
                    </svg>
                  </div>
                  <div class="tariff-item__content">
                    <div class="tariff-item__title">{{$t("tv")}}</div>
                    <div class="tariff-item__descr color-gray">{{tariff?.television?.titleRu}}</div>
                  </div>
                </div>
              </div>
              <div class="col-12 col-md-6" v-if="tariff.phoneIncluded">
                <div class="tariff-item">
                  <div class="tariff-item__icon svg-icon color-green" aria-hidden="true">
                    <svg role="img" width="50" height="50" aria-hidden="true">
                      <use xlink:href="#svg-icon-telephony"></use>
                    </svg>
                  </div>
                  <div class="tariff-item__content">
                    <div class="tariff-item__title">{{$t("telephony")}}</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="tariff-block__descr section__descrition color-gray">
              <p>{{tariff?.descriptionRu}}</p>
              <!-- <p>Единовременная плата за инсталляционные работы на стороне абонента 5000 тенге</p> -->
            </div>
            <div class="row">
              <div class="col-12 col-md-6 tariff-block__price-block color-green">
                <div class="tariff-block__price">{{tariff?.price}}</div>
                <div class="tariff-block__price-title"><span class="line">{{$t("tenge")}}</span><span class="divider" aria-hidden="true"></span><span class="line">{{$t("month")}}</span></div>
              </div>
              <div class="col-12 col-md-6 tariff-block__price-year color-green">
                <ul class="tariff-block__price-item">
                  <li>{{$tc("priceForYear", 1, { year: "1" })}}: {{tariff?.priceOneYear}} {{$t("tenge")}}</li>
                  <li>{{$tc("priceForYear", 2, { year: "2" })}}: {{tariff?.priceTwoYear}} {{$t("tenge")}}</li>
                  <li>{{$tc("priceForYear", 2, { year: "3" })}}: {{tariff?.priceThreeYear}} {{$t("tenge")}}</li>
                </ul>
              </div>
            </div>
          </div>
          <div class="tariff-block__footer">
            <div class="row align-items-center">
              <div class="col-12 col-md-7">
                <button class="btn btn_more btn_white" type="button" @click="selectedTariff(tariff)">{{$t("connect")}}</button>
              </div>
              <div class="col-12 col-md-5">
                <button class="link" type="button" @click.prevent.stop="openAssistant('assistant-call')">{{$t("contactOperator")}}</button>
              </div>
            </div>
          </div>
        </div>
    </div>
</template>
<script>
import {mapState, mapGetters, mapMutations, mapActions} from 'vuex';
export default {
  props: {
    tariff: {
      type: Object,
      default: function () {
          return {
            titleRu: '',
            descriptionRu: '',
            price: '',
            internet: {
              internetSpeed: ''
            },
            television: {
              titleRu: ''
            },
            phoneIncluded: false
          }
      }
    },
  },
  methods: {
    ...mapMutations({
      setAssistantType: 'assistant/setAssistantType'
    }),
    openAssistant(assistantType) {
      const bodyElem = document.querySelector('body')
      if (!window.matchMedia("(min-width: 1px) and (max-width: 1199px)").matches) {
        bodyElem.classList.contains('assistant-hide') && bodyElem.classList.remove("assistant-hide")
      } else {
        bodyElem.classList.contains('assistant-hide') && bodyElem.classList.remove("assistant-hide")
        bodyElem.classList.contains('assistant-open') || bodyElem.classList.add("assistant-open")
      }
      this.setAssistantType(assistantType)
    },
    selectedTariff(tariff){
      this.$emit('selectTariff', tariff);
    },
  }
}
</script>
<style scoped>
.tariff-block__price{
  font-size: 30px;
  padding-right: 8px;
}
.tariff-block__price-year{
  align-items: center;
}
.tariff-block__price-item{
  font-size: 12px;
  padding-left: 10px;
}
</style>